import http from './public'
import { getStore } from '/utils/storage'

// 获取面料信息及其关联款式（旧接口，保留兼容）
export const getProductWapInfo = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/product/getProductWapInfo', params)
}

// 拆分接口 - 产品基础信息
export const getProductWapBase = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/wap/getProductWapBase', params)
}

// 拆分接口 - WAP款式列表（静态缓存）
export const getWapDesigns = () => {
  return http.fetchPost('/picSearch/wes/wap/getWapDesigns')
}

// 拆分接口 - 收藏信息及关联面料
export const getWapFavoriteInfo = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/wap/getWapFavoriteInfo', params)
}

// 拆分接口 - 价格权限和库存
export const getWapPriceAndStock = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/wap/getWapPriceAndStock', params)
}

export const addProductFavorite = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/favorite-group-product/addFavorite', params)
}

export const delProductFavorite = (params) => {
  params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/favorite-group-product/delFavorite', params)
}

export const getStyle3dVideoUrl = (params) => {
  // params.userId = getStore('userId')
  return http.fetchPost('/picSearch/wes/design/getStyle3dVideoUrl', params)
}



// WEBPACK FOOTER //
// ./src/api/wap.js